import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Store } from '@ngrx/store';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';
import * as fromDashboardActions from 'src/app/state-management/actions/dashboard.action';
import * as fromCalendarActions from 'src/app/state-management/actions/calendar.actions';
import * as fromAdvancedSosActions from 'src/app/state-management/actions/advanced_sos.actions';
import * as fromAnalyticsActions from 'src/app/state-management/actions/analytics.actions';
import * as fromAssetsActions from 'src/app/state-management/actions/assets.actions';
import * as fromAuthActions from 'src/app/state-management/actions/authentication.actions';
import * as fromGuardActions from 'src/app/state-management/actions/guard.actions';
import * as fromManageUserActions from 'src/app/state-management/actions/manage-user.action';
import * as fromMediaWallActions from 'src/app/state-management/actions/media-wall.actions';
import * as fromReportsActions from 'src/app/state-management/actions/reports.actions';
import * as fromSecurityActions from 'src/app/state-management/actions/security.action';
import * as fromUserProfileActions from 'src/app/state-management/actions/user-profile.actions';
import { Router } from '@angular/router';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { ScreenType } from 'src/app/enums/ScreenType';
import { AumyeFirebaseRealtimeDbService } from 'src/app/services/realTimeData/aumye-firebase-realtime-db.service';
import { Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { IDashboardState } from 'src/app/state-management/states/aumye-dashboard.state';
import { MatDialog } from '@angular/material/dialog';
import { CreateNoticeBoardPostsComponent } from 'src/app/common/modules/user-notice-board/components/create-notice-board-posts/create-notice-board-posts.component';
import { ManageVisitorPassDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/manage-visitor-pass-dialog/manage-visitor-pass-dialog.component';
import { v4 as uuidv4 } from 'uuid';
import { AumyeEmergencyLocationService } from 'src/app/services/aumye-emergency-location.service';
import { HostVisitorStatusComponent } from '../security-pass/components/host-visitor-status/host-visitor-status.component';
import { MapsLocationDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/maps-location-dialog/maps-location-dialog.component';
import {
  AumyeRealTimeNotificationService,
  EventMessage,
} from 'src/app/services/aumye-real-time-notification.service';
import { environment } from 'src/app/environments/environments';
import { ComplaintsTickets } from 'src/app/models/tickets';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';
import { Capacitor } from '@capacitor/core';
import { LoadUserPatrolData } from 'src/app/state-management/actions/guard-patrol.actions';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  @ViewChild('drawer') sidenav: MatSidenav;
  @ViewChild('RequestDialog', { static: true })
  requestDialog: TemplateRef<any>;
  JNUOrgId = 'C2D6B9E3-A1F6-40B8-B860-883E6072C3F1';
  isExpanded = false;
  showFiller = false;
  constants: any;
  role = '';
  isDevice: boolean = false;
  isSecurity: boolean = false;
  isKiosk: boolean = false;
  screenSize: ScreenType;
  @ViewChild('IncidentAlert', { static: true }) IncidentAlert: TemplateRef<any>;
  loggedInOrgId: string = null;
  userId: string = null;
  destroyed$: Subject<any> = new Subject<any>();
  dashboardState$: Observable<IDashboardState>;
  dashboardData: IDashboardState;
  respondSoSData: any;
  disabledOrgIds: string[] = [];
  isDisableFeature: boolean = false;
  vendorRequestsData: ComplaintsTickets[] = [];
  encryptedData = localStorage.getItem('UserDetails');
  decryptedUserData: any;
  isNative: boolean = true;

  constructor(
    private store: Store<IAumyeState>,
    public router: Router,
    private cdRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private _screenSize: AumyeResponsiveScreenService,
    private firebaseRealTime: AumyeFirebaseRealtimeDbService,
    private aumyeEmergencyLocationService: AumyeEmergencyLocationService,
    private aumyeRealTimeNotificationService: AumyeRealTimeNotificationService,
    private encryptionService: EncryptionService
  ) {
    if (this.encryptedData == null) {
      this.encryptedData = localStorage.getItem('UserDetails');
    }
    this.decryptedUserData = lowerCaseFirstLetterOfKeys(
      this.encryptionService.decrypt(this.encryptedData)
    );
    this.role = this.decryptedUserData.role.toLowerCase();
    this.userId = this.decryptedUserData.userID.toLowerCase();
    this.loggedInOrgId = this.decryptedUserData.organizationID.toLowerCase();
    this.isSecurity = this.role == 'security';
    this.isDevice = this.role === 'device';
    this.isKiosk = this.role === 'kiosk';
    if (this.loggedInOrgId != '766773b7-51e9-4951-a2de-6245e6233758') {
      this.firebaseRealTime.initRealTime();
      this.firebaseRealTime.validateWebsocketToken();
    }

    this.dashboardState$ = this.store.select('aumyeDashboardState');
    this.dashboardState$.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.dashboardData = data;
      if (data && data.requestsTickets)
        this.vendorRequestsData = data.requestsTickets.filter(
          (x) => x.complainSubject === 'Vendor'
        );
    });
    this._screenSize.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });

    this._screenSize.getScreenType().subscribe((screenData) => {
      // this.setGlobalRootVariable();
      const root = document.documentElement;
      this.screenSize = screenData;

      if (screenData == ScreenType.Mobile) {
        const deviceWidth = window.innerWidth + 'px';
        document.documentElement.style.setProperty(
          '--device-width',
          deviceWidth
        );
        const tabFontSize = 14 + 'px';
        document.documentElement.style.setProperty(
          '--font-size-tab',
          tabFontSize
        );
        root.style.setProperty('--menu-width-open', '0px');
        root.style.setProperty('--menu-width-closed', '0px');
      } else if (screenData == ScreenType.Tablet) {
        const deviceWidth = 1020 + 'px';
        root.style.setProperty('--menu-width-open', '150px');
        if (this.isDevice || this.isKiosk)
          root.style.setProperty('--menu-width-closed', '0px');
        else root.style.setProperty('--menu-width-closed', '50px');
        document.documentElement.style.setProperty(
          '--device-width',
          deviceWidth
        );
      } else if (screenData == ScreenType.Desktop) {
        const deviceWidth = 1440 + 'px';
        document.documentElement.style.setProperty(
          '--device-width',
          deviceWidth
        );
        root.style.setProperty('--menu-width-open', '200px');
        // root.style.setProperty('--menu-width-closed', '64px');
        if (this.isDevice || this.isKiosk)
          root.style.setProperty('--menu-width-closed', '0px');
        else root.style.setProperty('--menu-width-closed', '64px');
      }
    });
  }
  isFetched = false;
  events: EventMessage[] = [];
  private subscription: Subscription;
  ngOnInit(): void {
    this.isNative = Capacitor.isNativePlatform();
    this.disabledOrgIds = environment.printerAllowed;
    this.isDisableFeature = this.disabledOrgIds
      .map((id) => id.toLowerCase())
      .includes(this.loggedInOrgId);
    const currentPath = this.router.url.split('?')[0];
    if (currentPath == '/dashboard/delete-my-account') {
      console.log('check me hrer ');
      // this.router.navigateByUrl('/dashboard/delete-my-account');
    } else if (currentPath !== '/dashboard/view') {
      localStorage.setItem('IsLink', 'false');
      if (this.isDevice) this.router.navigateByUrl('/dashboard/employee');
      // else if (this.isKiosk) this.router.navigateByUrl('/dashboard/guard');
      else {
        this.store.dispatch(new fromDashboardActions.InitDashboard({}));

        window.scrollTo(0, 0);
      }
    } else {
      localStorage.setItem('IsLink', 'true');
      if (!this.isFetched) {
        this.store.dispatch(new fromDashboardActions.LoadAllAssets({}));
        this.store.dispatch(new fromDashboardActions.GetUserList({}));
      }
    }

    if (this.isSecurity) {
      this.store.dispatch(new LoadUserPatrolData());
    }
  }

  setGlobalRootVariable() {
    const root = document.documentElement;
    if (this.screenSize == ScreenType.Desktop) {
      root.style.setProperty('--menu-width-open', '200px');
      root.style.setProperty('--menu-width-closed', '64px');
    }
    if (this.screenSize == ScreenType.Tablet) {
      root.style.setProperty('--menu-width-open', '150px');
      root.style.setProperty('--menu-width-closed', '50px');
    }
    if (this.screenSize == ScreenType.Mobile) {
      root.style.setProperty('--menu-width-open', '0px');
      root.style.setProperty('--menu-width-closed', '0px');
    }
  }
  updateIncidentData() {
    if (
      this.loggedInOrgId.toLocaleLowerCase() ===
      this.JNUOrgId.toLocaleLowerCase()
    ) {
      setInterval(() => {
        this.store.dispatch(new fromDashboardActions.UpdateIncidentList({}));
        this.store.dispatch(new fromDashboardActions.GetNumberPlatesList({}));
        // setTimeout(()=>{
        //   const audio = new Audio("");
        //   audio.play();
        // },2000);
      }, 15000);
    }
  }
  showSideMenu(val: Event) {}
  onChangeTabSelection(val: any) {
    if (val === 'dashboard') {
      this.store.dispatch(new fromDashboardActions.InitDashboard({}));
    } else if (val === 'reports') {
      this.store.dispatch(new fromDashboardActions.InitReportsTab({}));
      this.cdRef.detectChanges();
    } else if (val === 'analytics') {
      this.store.dispatch(new fromDashboardActions.InitAnalyticsTab({}));
    } else if (val === 'media') {
      this.store.dispatch(new fromDashboardActions.InitMediaWallTab({}));
    } else if (val === 'assets') {
      this.store.dispatch(new fromDashboardActions.InitAssetsTab({}));
    } else if (val === 'calendar') {
      this.store.dispatch(new fromDashboardActions.InitCalendarTab({}));
    } else if (val === 'manageuser') {
      this.store.dispatch(new fromDashboardActions.InitManageUserTab({}));
    } else if (val === 'settings') {
      this.store.dispatch(new fromDashboardActions.InitSettingsTab({}));
    } else if (val === 'scanQr') {
      this.store.dispatch(new fromDashboardActions.InitSecurityGuardTab({}));
    } else if (val === 'employee') {
      this.router.navigateByUrl('/dashboard/employee');
    } else if (val === 'security') {
      this.router.navigateByUrl('/dashboard/emergency');
    } else if (val === 'community') {
      this.router.navigateByUrl('/dashboard/community');
    }
  }
  userAccountSettings() {
    this.store.dispatch(new fromDashboardActions.InitUserProfile({}));
  }
  onOpenDrawer() {
    this.showFiller = !this.showFiller;
  }
  userLogOut() {
    this.store.dispatch(new fromDashboardActions.UserLogout({}));
    this.store.dispatch(new fromCalendarActions.ResetState({}));
    this.store.dispatch(new fromAdvancedSosActions.ResetState({}));
    this.store.dispatch(new fromAnalyticsActions.ResetState({}));
    this.store.dispatch(new fromAssetsActions.ResetState({}));
    this.store.dispatch(new fromAuthActions.ResetState({}));
    this.store.dispatch(new fromGuardActions.ResetState({}));
    this.store.dispatch(new fromManageUserActions.ResetState({}));
    this.store.dispatch(new fromMediaWallActions.ResetState({}));
    this.store.dispatch(new fromReportsActions.ResetState({}));
    this.store.dispatch(new fromSecurityActions.ResetState({}));
    this.store.dispatch(new fromUserProfileActions.ResetState({}));
  }
  clickedCreateUserPost(val: any) {
    this.store.dispatch(new fromDashboardActions.CreateNoticeBoardPost(val));
  }
  onShowNoticeBoard(val: any) {
    // this.showNoticeBoard = true;
    const dialogData = {
      screenSize: this.screenSize,
      users: this.dashboardData.orgUserList,
      loggedIsUsernameProfile: localStorage.getItem('ProfilePic'),
      loggedIsUsername: this.decryptedUserData.fullName,
    };
    const dialogRef = this.dialog.open(CreateNoticeBoardPostsComponent, {
      disableClose: true,
      data: dialogData,
    });
    dialogRef.componentInstance.onCreateUserPost.subscribe((data: any) => {
      this.clickedCreateUserPost(data);
    });
  }
  onOpenManageVisitorDialog() {
    const preApprovedVisitorList =
      this.dashboardData.visitorDetails.visitorList.filter(
        (visitor) => visitor.securityStatus == 1
      );
    const dialogRef = this.dialog.open(ManageVisitorPassDialogComponent, {
      disableClose: true,
      data: { visitor: preApprovedVisitorList, screen: this.screenSize },
    });
    dialogRef.componentInstance.onReNewVisitorPass.subscribe((data: any) => {
      this.store.dispatch(new fromDashboardActions.ManageVisitorPass(data));
    });
    dialogRef.componentInstance.onSuspendVisitorPass.subscribe((data: any) => {
      this.store.dispatch(new fromDashboardActions.ManageVisitorPass(data));
    });
  }
  clickedSaveUserInventory(val: any) {
    this.store.dispatch(new fromDashboardActions.SaveUserInventory(val));
  }
  onShowVisitorLogBook() {
    this.dialog.open(HostVisitorStatusComponent, {
      data: this.userId,
      height: this.screenSize == ScreenType.Mobile ? '470px' : '720px',
      width: this.screenSize == ScreenType.Mobile ? '320px' : '920px',
    });
  }
  getInventoryList() {
    // this.store.dispatch(new fromDashboardActions.GetUserInventory({}));
  }
  requestSOS(val: any) {
    this.store.dispatch(new fromDashboardActions.RequestSOS(val));
  }
  respondSOSRequest(val: any) {
    this.store.dispatch(new fromDashboardActions.RespondSOS(val));
  }
  onClickOpenMap() {}
  onRaiseRequest() {
    if (this.screenSize == ScreenType.Mobile) {
      this.dialog.open(this.requestDialog, {
        disableClose: false,
      });
      const requestId = uuidv4();
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const requestSosData = {
              currentLocation: position.coords,
              requestId: requestId,
            };
            this.requestSOS(requestSosData);
            this.aumyeEmergencyLocationService.addNewRequestToFirebase(
              requestSosData
            );
          },
          (error) => {
            window.alert(error);
          }
        );
      } else {
        window.alert('Geolocation is not supported by this browser');
      }
    } else {
      const dialogRef = this.dialog.open(MapsLocationDialogComponent, {
        data: { header: 'Request sos Location', isMultipleMarker: false },
      });
      dialogRef.afterClosed().subscribe((x) => {
        if (x) {
          this.dialog.open(this.requestDialog, {
            disableClose: false,
          });
          let newRes = JSON.parse(x);
          const requestId = uuidv4();
          const requestSosData = {
            currentLocation: { latitude: newRes.lat, longitude: newRes.lng },
            requestId: requestId,
          };
          this.requestSOS(requestSosData);
          this.aumyeEmergencyLocationService.addNewRequestToFirebase(
            requestSosData
          );
        }
      });
    }
  }
  ngOnDestroy() {
    this.aumyeRealTimeNotificationService.disconnect();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  // onRespondToRequest(val: IRequest) {
  //   const lat = val.requestLatitude;
  //   const long = val.requestLongitude;
  //   const respondId = uuidv4();
  //   if ('geolocation' in navigator) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         this.respondSoSData = {
  //           lat: position.coords.latitude,
  //           lng: position.coords.longitude,
  //           respondId: respondId,
  //           request: JSON.stringify(val),
  //         };
  //         this.respondSOSRequest(this.respondSoSData);
  //         const directionsURL = `https://www.google.com/maps/dir/?api=1&origin=${this.respondSoSData.lat},${this.respondSoSData.lng}&destination=${lat},${long}`;

  //         const confirmation = confirm(`Open directions in default map app?`);
  //         if (confirmation) {
  //           window.location.href = directionsURL;
  //         }
  //         this.dialog.closeAll();
  //       },
  //       (error) => {
  //         window.alert(error);
  //       }
  //     );
  //   } else {
  //     window.alert('Geolocation is not supported by this browser');
  //   }
  // }
  ScreenType = ScreenType;
}

function lowerCaseFirstLetterOfKeys(obj: any): any {
  return Object.keys(obj).reduce((acc: any, key: string) => {
    const newKey = key.charAt(0).toLowerCase() + key.slice(1);
    acc[newKey] = obj[key];
    return acc;
  }, {});
}
